<template>
    <div v-wechat-title="title" class="schedulesetup">
        <el-row>
            <el-col :span="24">
                <el-container style="margin-left: 10px; margin-right: 10px">
                    <el-header style="height: 30px;">
                        <el-row type="flex">
                            <el-col :span="5" :style="{
                                    fontSize: activeSchedule.title_font_size ? activeSchedule.title_font_size + 'px' : '15px',
                                    color: activeSchedule.title_color ? `rgb(${activeSchedule.title_color})` : 'black'
                                }" style="display: flex; align-items:center;text-align: left;">{{ activeSchedule.schedule_title }}
                                <el-tag size="small" v-if="schedule_result.status == 2" type="success">已发布</el-tag>
                                            <el-tag v-else-if="schedule_result.status == 1" type="warning">未发布</el-tag><el-tag v-else type="danger">已停用</el-tag>
                            </el-col>
                            <el-col :span="6" style="display:flex;align-items: center;">
                                <el-button-group>
                                    <el-button size="mini" @click="addDate(-1)">上一日</el-button>
                                    <el-button size="mini" @click="addDate(0)">今日</el-button>
                                    <el-button size="mini" @click="addDate(1)">下一日</el-button>
                                </el-button-group>
                                <el-date-picker ref="weekPicker" size="mini" prefix-icon="" v-model="dateValue"
                                    type="date" placeholder="选择日期" :style="{ margin: '0 5px' }"> </el-date-picker>
                            </el-col>
                            <el-col :span="4" style="text-align: left;">
                                <el-button-group>
                                    <el-button type="primary" size="mini" :style="{ borderRadius: '4px' }"
                                        v-if="schedule_result.status == 1 && (!isLock || showedit) && IsHavePermission(editPermission)"
                                        @click="save(1, true)">保存</el-button>
                                    <el-button type="primary" size="mini" :style="{ borderRadius: '4px' }"
                                        v-if="schedule_result.status == 1 && (!isLock || showedit) && IsHavePermission(editPermission)"
                                        @click="del()">清空</el-button>
                                    <el-button type="primary" size="mini" :style="{ borderRadius: '4px' }" v-if="schedule_result.status == 1 && (!isLock || showedit) && IsHavePermission(publishPermission)"
                                        @click="save(2, true)">发布</el-button>
                                    <el-button type="primary" size="mini" :style="{ borderRadius: '4px' }"
                                        v-if="IsHavePermission(editPermission) && isLock && !showedit"
                                        @click="unlock(1)">解锁</el-button>
                                    <el-button type="primary" size="mini" :style="{ borderRadius: '4px' }"
                                        v-if="schedule_result.status == 1 && (!isLock || showedit) && IsHavePermission(editPermission)"
                                        @click="copy()">复制</el-button>
                                </el-button-group>
                            </el-col>
                            <el-col :span="3" style="text-align: left;">
                                <el-button :span="6" style="margin-right: 10px;" type="primary" size="mini" :style="{ borderRadius: '4px' }"
                                    v-if="IsHavePermission(editUserGroupPermission)"
                                    @click="userGroupMaintenance()">人员维护</el-button>
                            </el-col>
                        </el-row>
                    </el-header>
                    <div v-drag="dialogLoction" class="user_left_box" v-show="!isHide">
                        <div class="userlisttitle">
                            <i class="el-icon-user-solid"></i>
                            人员列表
                        </div>
                        <el-scrollbar :style="{ height: `${this.screenHeight2 - 300}px` }">
                            <el-menu :unique-opened="false" :default-openeds="openeds">
                                <template v-for="g in schedule_userGroup">
                                    <el-submenu :index="g.id.toString()" :key="g.id" style="padding: 0 0px !important"
                                        class="submenu_user">
                                        <div slot="title" style="padding: 0 0px; font-size: 16px">
                                            <h1
                                                style="text-align: left; padding: 0px 30px 0px 5px; margin: 8px 0px 8px 0px">
                                                {{ g.name }}<span class="fg-info">({{ (g.users && g.users.length) || 0
                                                    }})</span>
                                                <!-- <i class="el-icon-edit" @click.stop="editUserGroup(g)"></i>-->
                                            </h1>
                                        </div>
                                        <div v-if="g.users && g.users.length > 0">
                                            <template v-for="d in g.users">
                                                <div class="user" :key="d.worker_id"
                                                    @click="selectUser(d, g.back_color, g.is_multi_duty, g)"
                                                    :style="{ backgroundColor: `rgb(${g.back_color})` }">
                                                    <span @mousedown="startLongPress(d.worker_name)"
                                                        @mouseup="endLongPress" @mouseleave="endLongPress">{{
                                                        d.worker_name }}</span>
                                                </div>
                                            </template>
                                        </div>
                                    </el-submenu>
                                </template>
                            </el-menu>
                        </el-scrollbar>
                    </div>
                    <el-main :style="{ height: `${this.screenHeight2 - 35}px` }">
                        <div id="aaaa" :style="{pointerEvents: schedule_result.status == 1 && (!isLock || showedit)?'auto':'none'}">
                            <table
                                style="table-layout: fixed;height: 100%;"
                                v-if="schedule_wards.length > 0" cellspacing="1" cellpadding="0">
                                <thead>
                                    <tr class="header">
                                        <th class="lefttitle" @click="showUserGroup"></th>
                                        <th v-for="(role, index) in repeatScheduleRoles" :key="index"
                                            :style="{ width: (roleColumns) * 42 + 'px'}"
                                            :colspan="roleColumns" @click="showUserGroup">
                                            <div style="margin:auto;text-align:center;">{{ role }}</div>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody v-for="(ward, w_index) in schedule_wards" :key="w_index">
                                    <tr class="header">
                                        <td :rowspan="ward.rowspans + 1" @click="showUserGroup"><div>{{ ward.dic_ward_name }}</div></td>
                                        <!-- dic_room_id > 0 判断是否系统标准手术间,标准手术间 按2列 展示，自己手动添加的非标准手术间，按自己设置的多少列展示 :class="{'roomtr':room.dic_room_id > 0 , 'tdflex': room.dic_room_id <= 0 }" -->
                                        <td v-for="(room, r_index) in ward.rooms"
                                            :key="w_index + '_' + r_index"
                                            :colspan="room.dic_room_id > 0 ? roleColumns * schedule_dutys.length : room.column_counts * schedule_dutys.length"
                                            style="text-align:center;color:#3c5657"
                                            :style="{ backgroundColor: room.dic_room_id > 0 ? '#E5F3FF' : '#a5cdd5' }"
                                            :class="{'roomtr':room.dic_room_id > 0, 'customroomstyle':room.dic_room_id <= 0}"
                                            @click="showRoomSurgerys(room.dic_room_id)">
                                            <div>{{ room.dic_room_name }}</div>
                                        </td>
                                        <td style="background:#a5cdd5;" v-if="(repeatScheduleRoles.length * roleColumns) - ward.wardcells > 0"
                                            :colspan="(repeatScheduleRoles.length * roleColumns) - ward.wardcells"
                                            ></td>
                                    </tr>
                                    <tr v-for="(row, idx) in ward.rowspans" :key="w_index + '_' + idx">
                                    <template
                                        v-for="(room, room_index) in ward.rooms">
                                                <td v-for="cel in room.column_counts" :key="room_index + '_' + cel"
                                                class="OnInTableTd"
                                                @click="setActiveItem(ward.dic_ward_id, room.dic_room_id, room.dic_room_name, null, row, cel)">
                                                        <div class="OnInTableDiv"
                                                            :class="{ td_div: isActive(ward.dic_ward_id, room.dic_room_name, null, row, cel) }">
                                                            <div style="width:100%;"
                                                                v-for="(worker, w_index) in getResultItems(ward.dic_ward_id, room.dic_room_name, null, row, cel)"
                                                                :key="rindex + '_' + w_index"
                                                                :style="{ backgroundColor: `rgb(${worker.back_color})` }"
                                                                class="vertical_text"
                                                                @dblclick="showDoctorInfo(worker)">
                                                                {{ worker.worker_name }}
                                                            </div>
                                                        </div>
                                                </td>
                                    </template>
                                        <td class="OnInTableTd" v-if="(repeatScheduleRoles.length * roleColumns)  - ward.wardcells > 0"
                                            :colspan="(repeatScheduleRoles.length * roleColumns)  - ward.wardcells"></td>
                                    </tr>
                                    <tr class="roomtr" style="height:28px !important;padding:0px;">
                                        <td class="header lefttitle">备注</td>
                                    <template
                                        v-for="(room, room_index) in ward.rooms">
                                                <td v-for="cel in room.column_counts" :key="room_index + '_' + cel"
                                                class="OnInRemarkTd"
                                                style="height:28px !important;padding:0px;"
                                                @click="setActiveItem(ward.dic_ward_id, room.dic_room_id, room.dic_room_name, null, ward.rowspans + 1, cel)">
                                                        <div class="OnInRemarkDiv"
                                                            @click="showRemarkVisible(ward.dic_ward_id, room.dic_room_id, room.dic_room_name, null, ward.rowspans + 1, cel)"
                                                            :class="{ td_div: isActive(ward.dic_ward_id, room.dic_room_name, null, ward.rowspans + 1, cel) }">
                                                            <input type="text" readonly="true"
                                                                v-for="(item, td_index) in getResultItems(ward.dic_ward_id, room.dic_room_name, null, ward.rowspans + 1, cel)"
                                                                :key="w_index + '_' + td_index"
                                                                style="width:100% !important;" v-model="item.remark" />
                                                        </div>
                                                </td>
                                    </template>
                                        <td style="background:#ffffff" v-if="(repeatScheduleRoles.length * roleColumns)  - ward.wardcells > 0"
                                            :colspan="(repeatScheduleRoles.length * roleColumns)  - ward.wardcells"></td>
                                    </tr>
                                </tbody>
                            </table>
                            <table ref="shift" style="table-layout: fixed;height: 100%;" cellspacing="1" cellpadding="0" v-if="schedule_sifts.length > 0">
                                <thead>
                                    <tr class="header">
                                        <th class="lefttitle" @click="showUserGroup"></th>
                                        <th v-for="(shift, s_index) in schedule_sifts"
                                            :style="{ width: shift.column_counts * 42 + 'px', backgroundColor:'#a5cdd5',color:'#3c5657' }"
                                            :colspan="shift.column_counts" :key="s_index"
                                            @dblclick="showShiftScheduleInfo(shift.dic_shift_id)">
                                            {{ shift.dic_shift_name }}
                                        </th>
                                        <th :style="{ width: 7 * 42 + 'px', backgroundColor:'#a5cdd5',color:'#3c5657' }" colspan="7">通告</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="activeSchedule.is_shift_multward"
                                        v-for="(row, r_index) in shiftRows" :key="r_index">
                                        <td class="header lefttitle" @click="showUserGroup"></td>
                                        <template
                                            v-for="(shift, s_index) in schedule_sifts">
                                                    <td v-for="cel in shift.column_counts" :key="s_index + '_' + cel"
                                                    class="OnInTableTd"
                                                    style="height: 40px;padding:0px;"
                                                    @click="setActiveItem(null, null, null, shift.dic_shift_id, row, cel)">
                                                    <div class="OnInTableDiv"
                                                        :class="{ td_div: isActive(null, null, shift.dic_shift_id, row, cel) }">
                                                        <div style="width:100%;"
                                                            v-for="(worker, windex) in getResultItems(null, null, shift.dic_shift_id, row, cel)"
                                                            :key="cindex + '_' + windex" class="vertical_text"
                                                            :style="{ backgroundColor: `rgb(${worker.back_color})` }"
                                                            @dblclick="showDoctorInfo(worker)">
                                                            {{ worker.worker_name }}
                                                        </div>
                                                    </div>
                                                    </td>
                                        </template>
                                        <td :rowspan="shiftRows" @click="showNotice(activeSchedule)" v-if="row == 1"
                                            style="text-align: left;align-content: start;background: #ffffff;"
                                            colspan="7">
                                            {{ activeSchedule.notice }}
                                        </td>
                                    </tr>
                                    <tr v-if="!activeSchedule.is_shift_multward"
                                        v-for="(ward, w_index) in schedule_wards" :key="w_index">
                                        <td class="header lefttitle" @click="showUserGroup">
                                            <div>{{ ward.dic_ward_name }}</div>
                                        </td>
                                        <template
                                            v-for="(shift, s_index) in schedule_sifts">
                                                    <td v-for="cel in shift.column_counts" :key="s_index + '_' + cel"
                                                    class="OnInTableTd"
                                                    style="height: 58px;padding:0px;"
                                                    @click="setActiveItem(ward.dic_ward_id, null, null, shift.dic_shift_id, row, cel)">
                                                    <div class="OnInTableDiv"
                                                        :class="{ td_div: isActive(ward.dic_ward_id, null, shift.dic_shift_id, row, cel) }">
                                                        <div style="width:100%;"
                                                            v-for="(worker, windex) in getResultItems(ward.dic_ward_id, null, shift.dic_shift_id, row, cel)"
                                                            :key="cindex + '_' + windex" class="vertical_text"
                                                            :style="{ backgroundColor: `rgb(${worker.back_color})` }"
                                                            @dblclick="showDoctorInfo(worker)">
                                                            {{ worker.worker_name }}
                                                        </div>
                                                    </div>
                                                    </td>
                                        </template>

                                        <td :rowspan="shiftRows" v-if="w_index == 0" colspan="7"
                                            style="background: #ffffff;">{{
                                            activeSchedule.notice }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </el-main>
                </el-container>
            </el-col>
        </el-row>
        <el-dialog :title="publishRecord.title" :close-on-click-modal="false"
            :visible.sync="publishRecord.dialogFormVisible" class="table-h560" width="60%">
            <el-row>
                <el-col :span="6">
                    <item-input type="daterange" v-model="rdate" :noPadding="true"></item-input>
                </el-col>
            </el-row>
            <ListView :datalist="publishRecord.data" :columns="publishRecord.columns" :buttons="publishRecord.buttons"
                @extrabutton-click="ExtraButtonClick"></ListView>
            <span slot="footer" class="dialog-footer">
                <el-button @click="publishRecord.dialogFormVisible = false">关 闭</el-button>
            </span>
        </el-dialog>
        <el-dialog :title="roomSurgerys.title" :close-on-click-modal="false"
            :visible.sync="roomSurgerys.dialogFormVisible" class="table-h560" width="60%">
            <ListView :datalist="roomSurgerys.data" :columns="roomSurgerys.columns"></ListView>
            <span slot="footer" class="dialog-footer">
                <el-button @click="roomSurgerys.dialogFormVisible = false">关 闭</el-button>
            </span>
        </el-dialog>
        <el-dialog :title="doctorInfo.title" :close-on-click-modal="false" :visible.sync="doctorInfo.dialogFormVisible"
            width="38%">
            <el-row>
                <el-col :span="6">
                    <div style="height:120px;margin-top:-4px;">
                        <img style="height:120px;width:120px;"
                            v-if="doctorInfo.data.picture && doctorInfo.data.picture.length > 0"
                            :src="doctorInfo.data.picture[0].url" />
                        <font-awesome-icon v-else :icon="['fas', 'user-nurse']" size="7x"></font-awesome-icon>
                    </div>
                </el-col>
                <el-col :span="18">
                    <el-row style="height:40px;">
                        <el-col :span="12" style="text-align: left;"> 员工号：{{ doctorInfo.data.card_no }} </el-col>
                        <el-col :span="12" style="text-align: left;">员工号：{{ doctorInfo.data.name }}</el-col>
                    </el-row>
                    <el-row style="height:40px;">
                        <el-col :span="12" style="text-align: left;">职务：{{ doctorInfo.data.worker_duty }}</el-col>
                        <el-col :span="12" style="text-align: left;">职称：{{
                            getProfessionalNameById(doctorInfo.data.enum_professional) }}</el-col>
                    </el-row>
                    <el-row style="height:40px;">
                        <el-col :span="12" style="text-align: left;">入职时间：{{ doctorInfo.data.entry_time &&
                            $moment(doctorInfo.data.entry_time).format(`YYYY/MM/DD`) }}</el-col>
                        <el-col :span="12" style="text-align: left;">教学资质：{{ doctorInfo.data.teaching_qualifications
                            }}</el-col>
                    </el-row>
                </el-col>
            </el-row>
            <!--301没用起来暂时注释-->
            <!-- <div>
                <div class="redtitle"><span>√轮转专科</span><span>●未轮转专科</span></div>
                <div class="sectiontable">
                    <el-row justify="space-between">
                        <el-col :span="6" v-for="(s, index) in section_auth" :key="index">
                            <div class="sectionname">{{s.label}}</div>
                            <div class="sectionselect">{{doctorInfo.data.rotation_sectionids==null ?
                                '●':(doctorInfo.data.rotation_sectionids.find(i=>i==s.value) ?'√':'●')}}</div>
                        </el-col>
                    </el-row>
                </div>
            </div> -->
            <span slot="footer" class="dialog-footer">
                <el-button v-if="schedule_result.status == 1" type="primary"
                    @click="delSchedule(doctorInfo.scheduleInfo)">删除排班</el-button>
                <el-button @click="doctorInfo.dialogFormVisible = false">关 闭</el-button>
            </span>
        </el-dialog>
        <el-dialog ref="form_unlock" title="解锁" :close-on-click-modal="true"
            :visible.sync="alterPasswordDialog.dialogFormVisible" width="30%">
            <el-row>
                <el-input v-model="alterPasswordDialog.data.uid" ref="uid" :clearable="true" :autofocus="true">
                    <template slot="prepend">
                        <i class="el-icon-user"></i>
                    </template>
                </el-input>
            </el-row>
            <el-row>
                <el-input v-model="alterPasswordDialog.data.pwd" ref="pwd" show-password :clearable="true">
                    <template slot="prepend">
                        <i class="el-icon-lock"></i>
                    </template>
                </el-input>
            </el-row>
            <el-row slot="footer" class="dialog-footer">
                <el-button @click="alterPasswordDialog.dialogFormVisible = false" icon="el-icon-unlock">取 消</el-button>
                <el-button type="primary" @click="saveLock()" icon="el-icon-unlock">确 定</el-button>
            </el-row>
        </el-dialog>
        <el-dialog title="备注" :close-on-click-modal="false" :visible.sync="roleremark.dialogFormVisible"
            class="table-h560" width="30%">
            <el-row>
                <el-col :span="24">
                    <el-input type="string" v-model="roleremark.resultItem.remark" @focus="handlerSoGoInput()"
                        maxlength="10"></el-input>
                </el-col>
            </el-row>
            <span slot="footer" class="dialog-footer">
                <el-button @click="roleremark.dialogFormVisible = false">关 闭</el-button>
                <el-button type="primary" @click="saveRemark(roleremark.resultItem)" icon="el-icon-unlock">确
                    定</el-button>
            </span>
        </el-dialog>
        <el-dialog title="班次人员统计" :visible.sync="shiftSchedule.dialogFormVisible" class="table-h560"
            :close-on-click-modal="false" width="40%">
            <crud-facecade-tree id="shiftworkerlist" ref="shiftworker-list" :url="shiftScheduleUrl" :treeCol="treeCol"
                :columns="shiftSchedule.columns" :expandall="false" :buttons="[]" :parentField="parentField"
                :addButton="{ enabled: false }" :updateButton="{ enabled: false }" :fuzzySearch="false" :stripe="false">
                <template slot="filter">
                    <el-col :span="12">
                        <item-input type="daterange" v-model="shiftrdate" :noPadding="true"></item-input>
                    </el-col>
                    <el-col :span="5">
                        <item-input type="select" v-model="dic_worker_id" :options="usernameList" :clearable="true"
                            placeholder="请选择人员"></item-input>
                    </el-col>
                    <el-col :span="7">
                        <item-input type="checkboxgroup" :options="shiftSchedule.configColumns"
                            v-model="shift_config_columns"></item-input>
                    </el-col>
                </template>
            </crud-facecade-tree>
        </el-dialog>
        <el-dialog ref="form_UserGroup" title="人员维护" :close-on-click-modal="true"
            :visible.sync="userGroupForm.dialogFormVisible" width="25%">
            <el-form id="GroupUser" label-position="right" label-width="80px !important"
                style="padding-top: 0px !important;">
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="姓名" style="padding-top: 0px !important;">
                            <el-input placeholder="请输入姓名" v-model="userGroupForm.workerinfo.name" size="small"
                                :readonly="userGroupForm.workerReadonly" @focus="handlerSoGoInput()">
                                <el-button :disabled="userGroupForm.workerReadonly" slot="append" icon="el-icon-search"
                                    @click="selectWorker(userGroupForm.workerinfo.name)"></el-button>
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="15">
                        <el-form-item label="员工号" style="padding-top: 0px !important;">
                            <item-input type="string" v-model="userGroupForm.workerinfo.card_no"
                                placeholder="   请输入员工号"></item-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5">
                        <el-form-item label="状态" style="padding-top: 0px !important;">
                            <item-input type="rbool" style="text-align: left;"
                                v-model="userGroupForm.workerinfo.is_deleted" :options="[
                                    { label: `启用`, value: false, type: `info` },
                                    { label: `禁用`, value: true, type: `danger` }
                                ]" disabled></item-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col>
                        <el-form-item label="所在组" style="padding-top: 0px !important;">
                            <item-input type="select" v-model="userGroupForm.workerinfo.dic_group_id_new"
                                :options="userGroupForm.userGroup" :clearable="true"
                                placeholder="   请选择所在组"></item-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col>
                        <el-form-item label="所属科室" style="padding-top: 0px !important;">
                            <item-input type="select" v-model="userGroupForm.workerinfo.dic_section_id"
                                :options="section_auth" :clearable="true" placeholder="   请选择所属科室"></item-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col>
                        <el-form-item label="职务" style="padding-top: 0px !important;">
                            <item-input type="select" v-model="userGroupForm.workerinfo.enum_worker_duty"
                                :options="this.sys_enums.WorkerDuty" :clearable="true"
                                placeholder="   请选择职务"></item-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="userGroupForm.dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveUserGroup()">确 定</el-button>
            </div>
        </el-dialog>
        <cus-dialog title="选择复制日期" :visible.sync="copyTo.dialogFormVisible" width="15%" @confirm="copyToDateConfirm()">
            <div class="margin10 margin-none-h align-left">
                <item-input type="date" v-model="copyTo.from_to" :noPadding="true"></item-input>
            </div>
        </cus-dialog>
        <el-dialog title="通告" :close-on-click-modal="false" :visible.sync="notice.dialogFormVisible" class="table-h560"
            width="30%">
            <el-row>
                <el-col :span="24">
                    <el-input type="textarea" :rows="4" v-model="notice.content"></el-input>
                </el-col>
            </el-row>
            <span slot="footer" class="dialog-footer">
                <el-button @click="notice.dialogFormVisible = false">关 闭</el-button>
                <el-button type="primary" @click="saveNotice(notice.content)" icon="el-icon-unlock">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import JSEncrypt from 'jsencrypt/bin/jsencrypt.min'
import draggable from 'vuedraggable'
import { mapGetters } from 'vuex'
export default {
    name: `UnLoginDoctorScheduleSetup`,
    props: {},
    components: { draggable },
    data() {
        return {
            longPressActive: false,
            shiftScheduleUrl: {
                baseURL: `api/AcisSystem/ScheduleResultDetail`,
                get: () => {
                    return new Promise((resolve, reject) => {
                        this.loadShiftScheduleInfo(resolve, reject)
                    })
                }
            },
            parentField: `worker_name`,
            treeCol: `姓名/排班`,
            shiftSchedule: {
                dialogFormVisible: false,
                columns: [
                    {
                        type: `string`,
                        prop: `id`,
                        label: `编号`,
                        isListable: false,
                        isExpand: false,
                        isKey: true
                    },
                    {
                        type: `string`,
                        prop: `group_name`,
                        label: `姓名/排班`,
                        isListable: true
                    },
                    {
                        type: `string`,
                        prop: `count`,
                        label: `次数`,
                        isListable: true
                    },
                    {
                        type: `string`,
                        prop: `type_name`,
                        label: `类型`,
                        isListable: true
                    }
                ],
                configColumns: [
                    {
                        value: `0`,
                        label: `工作日`
                    },
                    {
                        value: `1`,
                        label: `周末`
                    }
                ]
            },
            shiftrdate: [
                this.$moment()
                    .startOf(`month`)
                    .format(`YYYY/MM/DD`),
                this.$moment().format(`YYYY/MM/DD`)
            ],
            scheduleLockTime: this.$root.ScheduleLockTime || `8:00`,
            userGroupForm: {
                dialogFormVisible: false,
                workerReadonly: false,
                firstOpen: true,
                workerinfo: {},
                userGroup: []
            },
            dic_worker_id: null,
            shift_config_columns: [`0`, `1`],
            usernameList: [],
            title: `手术区护士排班`,
            token: this.$route.query.token,
            user: this.$route.query.user,
            newuser: this.$route.query.newuser,
            activeScheduleId: 0,
            activeSchedule: {},
            schedules: [],
            viewType: `day`, // 默认显示周视图
            active_item: [null, null, null, null, null, null, null], // 1:dic_ward_id,2:room_id,3:room_name,4:enum_worker_duty_id,5:dic_shift_id,6:rowIdx,7:cellIdx,用来定位页面维护的一格
            o_active_item: null,
            onPicker: {
                firstDayOfWeek: 1
            },
            dateValue: this.$moment().format(`YYYY/MM/DD`),
            year: ``,
            month: ``,
            week: ``,
            day: ``,
            start: ``, // 起始日期
            end: ``, // 截止日期
            rdate: [
                this.$moment()
                    .add(-7, `days`)
                    .format(`YYYY/MM/DD`),
                this.$moment().format(`YYYY/MM/DD`)
            ],
            schedule_userGroup: [],
            schedule_sifts: [],
            schedule_sifts_copy: [],
            schedule_result: {},
            issave: false,
            scheduleTimeSpan: [],
            schedule_dutys: [],
            schedule_wards: [],
            save_schedule_result: null,
            printForm: {
                dialogFormVisible: false,
                from_to: [],
                day_doc_code: `SPDay001`,
                week_doc_code: `SPWeek001`,
                month_doc_code: `SPMonth001`,
                title: `日期区间`
            },
            publishRecord: {
                title: `发布记录`,
                data: [],
                columns: [
                    {
                        type: `string`,
                        prop: `id`,
                        label: `编号`,
                        isKey: true
                    },
                    {
                        type: `string`,
                        prop: `dic_ward`,
                        label: `手术区域`,
                        isListable: true,
                        width: 80
                    },

                    {
                        type: `string`,
                        prop: `dic_section`,
                        label: `科室`,
                        width: 80,
                        isListable: true
                    },
                    {
                        type: `string`,
                        prop: `start_to_end`,
                        label: `排班日期`,
                        isListable: true
                    },
                    {
                        type: `string`,
                        prop: `logtext`,
                        label: `类型`,
                        isListable: true
                    },
                    {
                        type: `string`,
                        prop: `creator`,
                        label: `发布人`,
                        isListable: true
                    },

                    {
                        type: `datetime`,
                        prop: `createdt`,
                        label: `发布时间`,
                        isListable: true
                    }
                ],
                dialogFormVisible: false
            },
            roomSurgerys: {
                title: `手术室信息`,
                data: [],
                columns: [
                    {
                        type: `string`,
                        prop: `id`,
                        label: `编号`,
                        isKey: true
                    },
                    {
                        type: `string`,
                        prop: `patient_name`,
                        label: `姓名`,
                        width: 120,
                        isListable: true
                    },
                    {
                        type: `string`,
                        prop: `scheduled_sequence`,
                        label: `台次`,
                        isListable: true
                    },
                    {
                        type: `datetime`,
                        prop: `plan_time`,
                        label: `安排时间`,
                        width: `120`,
                        isListable: true
                    },
                    {
                        type: `string`,
                        prop: `dic_section`,
                        label: `手术科室`,
                        width: `120`,
                        isListable: true
                    },
                    {
                        type: `string`,
                        prop: `surgeries`,
                        label: `手术名称`,
                        width: `180`,
                        isListable: true
                    },
                    {
                        type: `string`,
                        prop: `surgeon`,
                        label: `手术医师`,
                        width: `120`,
                        isListable: true
                    },
                    {
                        type: `string`,
                        prop: `surgeon_assistants`,
                        label: `手术助手`,
                        width: `120`,
                        isListable: true
                    },
                    {
                        type: `string`,
                        prop: `anaes_methods`,
                        label: `麻醉方式`,
                        width: `150`,
                        isListable: true
                    },
                    {
                        type: `string`,
                        prop: `anaes_surgeon`,
                        label: `麻醉医生`,
                        width: `150`,
                        isListable: true
                    },
                    {
                        type: `string`,
                        prop: `anes_assistants`,
                        label: `麻醉助手`,
                        width: `150`,
                        isListable: true
                    }
                ],
                dialogFormVisible: false
            },
            doctorInfo: {
                title: `护理人员信息`,
                worker_id: 0,
                data: [],
                columns: [],
                dialogFormVisible: false
            },
            loading: false,
            editPermission: `schedule_setup:edit`,
            publishPermission: `schedule_setup:publish`,
            exportPermission: `schedule_setup:export`,
            printPermission: `schedule_setup:print`,
            editUserGroupPermission: `schedule_setup:editUserGroup`,
            workerList: [],
            userInputRemark: null,
            remarks: [],
            permissions: [],
            alterPasswordDialog: {
                title: `解锁`,
                dialogFormVisible: false,
                data: {
                    uid: ``,
                    pwd: ``,
                    exp: 100000
                }
            },
            roleremark: {
                dialogFormVisible: false,
                resultItem: {}
            },
            notice: {
                dialogFormVisible: false,
                content: ``,
                scheduleId: 0
            },
            dialogTitle: ``,
            form: {
                id: 0,
                name: ``,
                status_b: true,
                relScheduleShiftUsers: [],
                back_color: ``,
                dicWardIds: [],
                dicSectionIds: [],
                shiftGroupUsers: [],
                shiftGroupUserarr: [
                    {
                        value: 0,
                        label: ``,
                        display_order: 1,
                        back_color: ``
                    }
                ],
                isCheckedColor: false,
                all_back_color: ``,
                selectWorkerRole: 0
            },
            showedit: false,
            dialogLoction: {
                top: 0,
                right: 0,
                width: `50%`,
                height: `450px`
            },
            isHide: true,
            copyTo: {
                dialogFormVisible: false,
                from_to: null
            },
            copyItem: null
        }
    },
    created() {
        if (this.token) {
            sessionStorage.setItem(`token`, this.token)
        }
        this.loadToken().then(() => {
            this.init()
        })
    },
    mounted() {},
    computed: {
        ...mapGetters([`screenHeight`, `screenWidth`, `sys_enums`, `sysuser/workers_by_duty`, `currentUser`, `sysuser/workers`, `active_ward`, `section_auth`, `ward_auth`]),
        isLock() {
            var selectday = new Date(this.$moment(this.day))
            var today = new Date(this.$moment().format(`YYYY/MM/DD`))
            var now = new Date(this.$moment())
            var lockTime = new Date(this.$moment().format(`YYYY/MM/DD ${this.scheduleLockTime}`))
            console.log(`isLock`, selectday < today || now > lockTime, selectday, today, now, lockTime)
            return selectday < today || now > lockTime
        },
        tomorrowLock() {
            var selectday = new Date(this.$moment(this.day))
            var tomorrow = new Date(
                this.$moment()
                    .add(1, `days`)
                    .format(`YYYY/MM/DD`)
            )
            console.log(`tomorrowLock`, selectday >= tomorrow)
            return selectday >= tomorrow
        },
        roleColumns() {
            return this.activeSchedule.role_column_count
        },
        repeatScheduleRoles() {
            let that = this
            let reportRoles = []
            let reportCount = that.tableCells / (that.schedule_dutys.length * that.roleColumns)
            for (let index = 0; index < reportCount; index++) {
                let workerdutynames = that.schedule_dutys.map(i => i.enum_worker_duty_name)
                reportRoles = reportRoles.concat(workerdutynames)
            }
            return reportRoles
        },
        roleCols() {
            let that = this
            let reportRoles = []
            let cols = that.tableCells / (that.schedule_dutys.length * that.roleColumns)
            for (let index = 0; index < cols; index++) {
                for (let j = 0; j < that.schedule_dutys.length; j++) {
                    for (let z = 0; z < that.roleColumns; z++) {
                        reportRoles.push(that.schedule_dutys[j].enum_worker_duty_id)
                    }
                }
            }
            return reportRoles
        },
        tableCells() {
            let that = this
            let rolelen = (that.schedule_dutys && that.schedule_dutys.length) || 0
            _.forEach(that.schedule_wards, ward => {
                let wardcells = 0
                _.forEach(ward.rooms, room => {
                    // 为了解决页面排版列对齐问题,id>0的系统标准手术间，每个标准手术间列数=角色 * roleColumns(角色列数)，手动加的非标准手术间，按room.column_counts 设置的倍数来，
                    // 如：大屏配置了 手术医生，手术助手，2个角色，每个角色 roleColumns 设置3列，则 2*3=6列，非标准手术间 column_counts 设置成 2 倍，则：2 *2*3 =12 列。
                    if (room.dic_room_id > 0) {
                        wardcells = wardcells + that.roleColumns * rolelen
                    } else {
                        wardcells = wardcells + room.column_counts * rolelen
                    }
                })
                let maxRowCountItem = _.maxBy(ward.rooms, `row_counts`)
                that.$set(ward, `rowspans`, (maxRowCountItem && maxRowCountItem.row_counts) || 0)
                that.$set(ward, `wardcells`, wardcells)
            })
            let wcells = _.maxBy(that.schedule_wards, `wardcells`)
            return (wcells && wcells.wardcells) || 0
        },
        shiftRows() {
            let that = this
            let maxRowCountItem = _.maxBy(that.schedule_sifts, `row_counts`)
            let wrows = (maxRowCountItem && maxRowCountItem.row_counts) || 0
            return wrows
        },
        screenHeight2() {
            return this.screenHeight
        },
        worker() {
            return this[`sysuser/workers_by_duty`]
        },
        openeds() {
            return this.schedule_userGroup.map(i => i.id.toString())
        },
        copyTitle() {
            let endstr = ``
            if (this.viewType == `day`) {
                endstr = `复制`
            } else {
                endstr = `复制上一周`
            }
            return endstr
        },
        isActive() {
            let that = this
            return function(dicwardid, roomname, dicshiftId, rowIdx, cellIdx) {
                // 哈哈哈，精准定位到哪个格子了
                let enumWorkerdutyId = dicshiftId > 0 ? null : that.roleCols[cellIdx - 1] // 点击班次 单元格 不需要 取角色
                return (
                    that.active_item[0] == dicwardid &&
                    that.active_item[2] == roomname &&
                    that.active_item[3] == enumWorkerdutyId &&
                    that.active_item[4] == dicshiftId &&
                    that.active_item[5] == rowIdx &&
                    that.active_item[6] == cellIdx
                )
            }
        },
        getResultItems() {
            let that = this
            return function(dicwardid, roomname, dicshiftId, rowIdx, cellIdx) {
                let results = []
                let enumWorkerdutyId = dicshiftId > 0 ? null : that.roleCols[cellIdx - 1] // 点击班次 单元格 不需要 取角色
                let item = that.getResultDetailItem(dicwardid, enumWorkerdutyId, roomname, dicshiftId, rowIdx, cellIdx)
                if (item) {
                    item.back_color = item.back_color || `255,255,255`
                    results.push(item)
                }
                return results || []
            }
        },
        shiftColSpan() {
            let totalShiftCols = 0
            this.schedule_sifts.map(i => {
                totalShiftCols = totalShiftCols + i.column_counts
            })
            return totalShiftCols + 1
        },
        IsHavePermission() {
            return permissionNo => {
                return _.find(this.permissions, { permission: permissionNo }) != undefined
            }
        }
    },
    methods: {
        startLongPress(workername) {
            let that = this
            this.longPressActive = true
            // 设置一个定时器，如果用户持续按住，则执行长按操作
            this.longPressTimer = setTimeout(() => {
                // 执行长按后的操作
                console.log(`Long press triggered`)
                that.userGroupForm.dialogFormVisible = true
                that.userGroupForm.firstOpen = true
                that.userGroupForm.workerReadonly = true
                that.selectWorker(workername)
            }, 500) // 长按500毫秒
        },
        endLongPress() {
            this.longPressActive = false
            // 清除定时器
            clearTimeout(this.longPressTimer)
        },
        startLongPressShift(shiftId) {
            let that = this
            this.longPressActive = true
            // 设置一个定时器，如果用户持续按住，则执行长按操作
            this.longPressTimer = setTimeout(() => {
                // 执行长按后的操作
                console.log(`Long press triggered`)
                that.showShiftScheduleInfo(shiftId)
            }, 500) // 长按500毫秒
        },
        endLongPressShift() {
            this.longPressActive = false
            // 清除定时器
            clearTimeout(this.longPressTimer)
        },
        ReloadListData() {
            let that = this
            this.$nextTick(() => {
                that.$refs[`shiftworker-list`].ReloadListData()
            })
        },
        loadShiftScheduleInfo(resolve, reject) {
            let that = this
            var reps = this.myaxios.get(`/api/AcisSystem/ScheduleResultDetail/GetShiftScheduleInfo`, {
                scheduleId: that.activeScheduleId,
                shiftId: that.shiftSchedule.shiftId,
                begin: that.shiftrdate[0],
                end: that.shiftrdate[1]
            })
            reps.then(data => {
                console.log(data)
                let weekday = [1, 2, 3, 4, 5]
                let weekend = [0, 6]
                if (!that.shift_config_columns.includes(`0`)) {
                    data = _.filter(data, x => !weekday.includes(x.dayOfWeek))
                }
                if (!that.shift_config_columns.includes(`1`)) {
                    data = _.filter(data, x => !weekend.includes(x.dayOfWeek))
                }
                that.usernameList = []
                let templates = []
                let groups = _.groupBy(data, `worker_id`)
                let groupid = 0
                _.forEach(groups, (value, key) => {
                    groupid = groupid - 1
                    let grouprow = {
                        id: groupid,
                        worker_id: key,
                        group_name: value[0].worker_name,
                        count: value.length,
                        children: [],
                        class_name: `groupClass`
                    }
                    grouprow.children = value
                        .sort((a, b) => this.$moment(a.schedule_date) - this.$moment(b.schedule_date))
                        .map((info, index) => {
                            info.group_name = index + 1
                            info.count = this.$moment(info.schedule_date).format(`YYYY-MM-DD`)
                            info.type_name = info.dayOfWeek == 0 ? `周日` : info.dayOfWeek == 6 ? `周六` : ``
                            return info
                        })
                    templates.push(grouprow)
                    that.usernameList.push({
                        label: grouprow.group_name,
                        value: parseInt(key)
                    })
                })

                if (that.dic_worker_id > 0) {
                    templates = _.filter(templates, x => x.worker_id == that.dic_worker_id)
                }
                console.log(that.usernameList)
                console.log(templates)
                resolve(templates)
            }).catch(e => {
                console.log(e)
                resolve([])
            })
        },
        userGroupMaintenance() {
            let that = this
            that.userGroupForm.dialogFormVisible = true
            that.userGroupForm.workerReadonly = false
            that.userGroupForm.workerinfo = {
                is_deleted: false
            }
        },
        selectWorker(workername) {
            let that = this
            return new Promise(resolve => {
                this.myaxios.get(`/api/AcisSystem/Worker/GetWorkerInfo?name=` + workername).then(data => {
                    console.log(data)
                    if (data) {
                        that.userGroupForm.dialogFormVisible = true
                        that.userGroupForm.firstOpen = false
                        that.userGroupForm.workerinfo = { ...data }
                        let worker = that.workerList.find(x => x.worker_id == data.id)
                        if (worker) {
                            that.userGroupForm.workerinfo.dic_group_id_old = worker.shift_user_group_id
                            that.userGroupForm.workerinfo.dic_group_id_new = worker.shift_user_group_id
                        }
                    } else {
                        this.$message.info(`未查询到员工信息，可新增`)
                        that.userGroupForm.workerinfo = {
                            name: workername,
                            is_deleted: false
                        }
                    }
                    resolve(that.userGroupForm.workerinfo)
                })
            })
        },
        saveUserGroup() {
            let that = this
            console.log(that.userGroupForm.workerinfo)
            if (that.userGroupForm.workerinfo) {
                if (!that.userGroupForm.workerinfo.dic_group_id_new) {
                    that.$message.error(`请选择人员所属班次`)
                    return
                }
                this.myaxios
                    .post(`/api/AcisSystem/ShiftUserGroup/ChangeUserGroup`, {
                        id: that.userGroupForm.workerinfo.id,
                        name: that.userGroupForm.workerinfo.name,
                        card_no: that.userGroupForm.workerinfo.card_no,
                        is_deleted: that.userGroupForm.workerinfo.is_deleted,
                        dic_group_id_old: that.userGroupForm.workerinfo.dic_group_id_old,
                        dic_group_id_new: that.userGroupForm.workerinfo.dic_group_id_new,
                        dic_section_id: that.userGroupForm.workerinfo.dic_section_id,
                        enum_worker_duty: that.userGroupForm.workerinfo.enum_worker_duty
                    })
                    .then(data => {
                        that.loadShiftUserGroup(that.activeScheduleId)
                        that.userGroupForm.dialogFormVisible = false
                        that.userGroupForm.workerinfo = {
                            is_deleted: false
                        }
                    })
            }
        },
        loadToken() {
            return new Promise(resolve => {
                if (this.newuser) {
                    this.user = decodeURIComponent(window.atob(this.newuser))
                }
                let username = this.user.split(`|`)[0]
                let password = this.user.split(`|`)[1]
                if (this.$root.PwdEncryptEnabled && this.$root.PwdEncryptEnabled == `1` && this.$root.RsaPublicKeyLogin) {
                    let encryptor = new JSEncrypt()
                    encryptor.setPublicKey(this.$root.RsaPublicKeyLogin)
                    password = encryptor.encrypt(password)
                }
                let req = this.myaxios.post(`/api/AcisSystem/Authorization/Login`, {
                    user_agent: `chrome`,
                    timestamp: new Date().getTime(),
                    data: {
                        uid: username,
                        pwd: password,
                        exp: 100000
                    }
                })
                req.then(data => {
                    sessionStorage.setItem(`token`, data)
                    resolve(data)
                })
            })
        },
        init() {
            this.$store.dispatch(`sysuser/ADD_WORKERS`)
            this.$store.dispatch(`enums/ADD_ALL_ENUM`)
            this.$store.dispatch(`ADD_WARD_AUTH`)
            this.$store.dispatch(`ADD_SECTION_AUTH`)
            // 设置视图显示模式,默认显示日视图
            this.changeDatePickerSetScheduleTimeSpan(this.dateValue, 0)
            this.$store.dispatch(`ADD_CURRENTUSER`).then(() => {
                this.loadPermissions()
                this.loadCurrentUserSchedules().then(activeScheduleId => {
                    this.loadActiveScheduleUserGroupsAndShifts(activeScheduleId).then(sifts => {
                        this.loadScheduleResultsAndCreateShiftTable()
                    })
                })
            })
        },
        loadPermissions() {
            return new Promise(resolve => {
                let req = this.myaxios.get(`/api/AcisSystem/Authorization/GetPermissions`) // 获取当前用户的权限
                req.then(data => {
                    this.permissions = data
                    resolve(data)
                }).catch(e => {})
            })
        },
        getResultDetailItem(dicwardid, workerdutyid, roomname, dicshiftId, rowIdx, cellIdx) {
            let that = this
            // 通过定位 到结果表里面去 查询人员，并返回人员
            let item = _.find(
                that.schedule_result.result_details,
                x =>
                    x.dic_schedule_id == that.activeScheduleId &&
                    x.dic_ward_id == dicwardid &&
                    x.room_name == roomname &&
                    x.enum_worker_duty_id == workerdutyid &&
                    x.dic_shift_id == dicshiftId &&
                    x.rowIdx == rowIdx &&
                    x.cellIdx == cellIdx
            )
            return item
        },
        saveAndloadDate(date) {
            if (this.schedule_result.status == 1 && this.day != date) {
                this.save(1, false) // 周视图下因切换 日期按钮触发的自动保存，直接保存 不需要给提示
                this.day = date
                this.loadScheduleResultsAndCreateShiftTable()
            }
        },
        showDoctorInfo(worker) {
            let that = this
            this.doctorInfo.dialogFormVisible = true
            this.doctorInfo.scheduleInfo = worker
            return new Promise(resolve => {
                let req = this.myaxios.get(`/api/AcisSystem/Worker/Get?id=${worker.worker_id}`)
                let req1 = this.myaxios.get(`/api/AcisSystem/Worker/GetFileNames/${worker.worker_id}`)

                that.myaxios.all(req, req1).then(([worker, photo]) => {
                    let fs = _.groupBy(photo, d3 => {
                        return d3.indexOf(`.pdf`) == -1 ? `image` : `pdf`
                    })

                    worker.picture =
                        (fs &&
                            fs.image &&
                            fs.image.map(d => {
                                return {
                                    name: d,
                                    url: `${this.$root.BASE_URL}api/AcisSystem/Worker/GetPictureFile/${worker.id}?fileName=${d}`,
                                    uid: `p${worker.worker_id}`
                                }
                            })) ||
                        []
                    that.doctorInfo.data = worker
                    resolve(that.doctorInfo.data)
                })
            })
        },
        delSchedule(scheduleInfo) {
            let resultDetail = this.schedule_result.result_details
            resultDetail.splice(resultDetail.indexOf(scheduleInfo), 1)
            this.doctorInfo.dialogFormVisible = false
        },
        getProfessionalNameById(id) {
            if (!id) return
            let item = _.find(this.sys_enums.Enum_Professional, x => x.value == parseInt(id))
            return item && item.label
        },
        showUserGroup() {
            this.isHide = !this.isHide
        },
        showRoomSurgerys(roomid) {
            let that = this
            that.roomSurgerys.dialogFormVisible = true
            return new Promise(resolve => {
                let req = this.myaxios.get(`/api/Preoperative/Schedule/GetScheduled`, { date: that.day, roomId: roomid })
                req.then(data => {
                    that.roomSurgerys.data = data
                    resolve(that.roomSurgerys.data)
                }).catch(e => {
                    console.log(e)
                    resolve([])
                })
            })
        },
        copy() {
            let item = this.getResultDetailItem(this.active_item[0], this.active_item[3], this.active_item[2], this.active_item[4], this.active_item[5], this.active_item[6])
            if (item) {
                this.copyItem = _.cloneDeep(item)
            }
        },
        selectUser(user, backColor, isMultiDuty, group) {
            let that = this
            if (that.schedule_result.status == 2 && (that.active_item[2] !== null || that.active_item[4] !== null)) {
                that.$message.error(`排班已发布,请取消发布后再设置`)
                this.active_item = [null, null, null, null, null, null, null] // 1:dic_ward_id,2:room_id,3:room_name,4:enum_worker_duty_id,5:dic_shift_id,6:rowIdx,7:cellIdx
                return
            }

            let newresultWorker = {
                dic_schedule_id: that.activeScheduleId,
                schedule_date: this.day,
                worker_name: user.worker_name,
                worker_id: user.worker_id,
                worker_code: user.worker_code,
                back_color: backColor // 使用组的颜色
            }

            let sameworker = _.find(this.schedule_result.result_details, x => x.worker_id == newresultWorker.worker_id)
            if (sameworker && !isMultiDuty) {
                this.$message.error(`此组人员不能多次排班!`)
                return
            }

            // newresultWorker 确定了当前 选择了哪个人， 通过 this.active_item 可以 确定 当前 点击 的 格子， 然后把格子的方位 给到
            // schedule_result.result_details 某条值，就完成了 排人到页面上的操作

            // 选中了手术间排到手术间里面,这里判断选择的是手术间格子
            if (that.active_item[0] !== null && that.active_item[2] !== null && that.active_item[3] !== null) {
                let sameworker = _.find(
                    this.schedule_result.result_details,
                    x => x.dic_ward_id == that.active_item[0] && x.room_name == that.active_item[2] && x.worker_id == newresultWorker.worker_id
                )
                if (sameworker) {
                    that.$message.error(`当前人在此手术间已经有排班`)
                    return
                }
                this.$set(newresultWorker, `dic_ward_id`, this.active_item[0])
                this.$set(newresultWorker, `room_id`, this.active_item[1])
                this.$set(newresultWorker, `room_name`, this.active_item[2])
                this.$set(newresultWorker, `enum_worker_duty_id`, this.active_item[3])
                this.$set(newresultWorker, `rowIdx`, this.active_item[5])
                this.$set(newresultWorker, `cellIdx`, this.active_item[6])
                let item = _.find(
                    this.schedule_result.result_details,
                    x => x.dic_ward_id == newresultWorker.dic_ward_id && x.room_name == newresultWorker.room_name && x.rowIdx == newresultWorker.rowIdx && x.cellIdx == newresultWorker.cellIdx
                )
                if (item) {
                    // 找到了 替换
                    this.$set(item, `worker_id`, newresultWorker.worker_id)
                    this.$set(item, `worker_code`, newresultWorker.worker_code)
                    this.$set(item, `worker_name`, newresultWorker.worker_name)
                    this.$set(item, `back_color`, newresultWorker.back_color)
                } else {
                    // 没找到了 加
                    this.schedule_result.result_details.push(newresultWorker)
                }
            }
            // 选中了班次排到班次里面 active_item[4] = dic_shift_id,这里判断选择的是班次格子
            if (that.active_item[2] == null && that.active_item[4] !== null) {
                this.$set(newresultWorker, `dic_ward_id`, this.active_item[0]) // 区域,跨区域的时候 =null
                this.$set(newresultWorker, `dic_shift_id`, this.active_item[4])
                this.$set(newresultWorker, `rowIdx`, this.active_item[5])
                this.$set(newresultWorker, `cellIdx`, this.active_item[6])
                let sameworker = _.find(
                    this.schedule_result.result_details,
                    x => x.dic_ward_id == that.active_item[0] && x.dic_shift_id == that.active_item[4] && x.worker_id == newresultWorker.worker_id
                )
                if (sameworker) {
                    that.$message.error(`当前人在此班次已经有排班`)
                    return
                }
                // 同一位置上是不是排了其它人
                let item = _.find(
                    this.schedule_result.result_details,
                    x => x.dic_ward_id == newresultWorker.dic_ward_id && x.dic_shift_id == newresultWorker.dic_shift_id && x.rowIdx == newresultWorker.rowIdx && x.cellIdx == newresultWorker.cellIdx
                )
                if (item) {
                    // 替换
                    this.$set(item, `worker_id`, newresultWorker.worker_id)
                    this.$set(item, `worker_code`, newresultWorker.worker_code)
                    this.$set(item, `worker_name`, newresultWorker.worker_name)
                    this.$set(item, `back_color`, newresultWorker.back_color)
                } else {
                    this.schedule_result.result_details.push(newresultWorker)
                }
            }
            // 翟有朋 ACIS-08811 ，要求 互斥，选择后 人员 直接从 选人框 移除
            group.users = group.users.filter(item => item.worker_id !== newresultWorker.worker_id)
            group.shiftGroupUsers = group.shiftGroupUsers.filter(i => i !== newresultWorker.worker_id)
            this.$forceUpdate()
        },
        setActiveItem(scheduleWardId, roomid, roomname, dicshiftId, rowIdx, cellIdx) {
            let enumWorkerdutyId = dicshiftId > 0 ? null : this.roleCols[cellIdx - 1] // 点击 班次单元格, 不用获取角色
            if (
                this.active_item[0] == scheduleWardId &&
                this.active_item[2] == roomname &&
                this.active_item[3] == enumWorkerdutyId &&
                this.active_item[4] == dicshiftId &&
                this.active_item[5] == rowIdx &&
                this.active_item[6] == cellIdx
            ) {
                // 选择状态下取消选中，格子被清空了
                this.active_item = [null, null, null, null, null, null, null]
                // 1:dic_ward_id,2:room_id,3:room_name,4:enum_worker_duty_id,5:dic_shift_id,6:rowIdx,7:cellIdx
            } else {
                // 格子被放上了定位
                this.active_item = [scheduleWardId, roomid, roomname, enumWorkerdutyId, dicshiftId, rowIdx, cellIdx]
                // 1:dic_ward_id,2:room_id,3:room_name,4:enum_worker_duty_id,5:dic_shift_id,6:rowIdx,7:cellIdx
            }
            // 是否点击了 复制功能
            this.setCopyItemToTable()
        },
        setCopyItemToTable() {
            if (this.copyItem) {
                let copyObj = _.cloneDeep(this.copyItem)
                this.$set(copyObj, `dic_ward_id`, this.active_item[0])
                this.$set(copyObj, `room_id`, this.active_item[1])
                this.$set(copyObj, `room_name`, this.active_item[2])
                this.$set(copyObj, `enum_worker_duty_id`, this.active_item[3])
                this.$set(copyObj, `dic_shift_id`, this.active_item[4])
                this.$set(copyObj, `rowIdx`, this.active_item[5])
                this.$set(copyObj, `cellIdx`, this.active_item[6])
                let item = _.find(
                    this.schedule_result.result_details,
                    x => x.dic_ward_id == copyObj.dic_ward_id && x.room_name == copyObj.room_name && x.rowIdx == copyObj.rowIdx && x.cellIdx == copyObj.cellIdx
                )
                if (item) {
                    // 找到了 替换
                    this.$set(item, `worker_id`, copyObj.worker_id)
                    this.$set(item, `worker_code`, copyObj.worker_code)
                    this.$set(item, `worker_name`, copyObj.worker_name)
                    this.$set(item, `back_color`, copyObj.back_color)
                } else {
                    // 没找到了 加
                    this.schedule_result.result_details.push(copyObj)
                }
                this.copyItem = null
            }
        },
        showShiftWorkerInfo(dicwardid, shiftid, workerId) {
            let item = _.find(this.schedule_result.result_details, x => x.dic_schedule_ward_id == dicwardid && x.dic_shift_id == shiftid && x.worker_id == workerId)
            if (item) {
                this.doctorInfo.dialogFormVisible = true
                this.doctorInfo.scheduleInfo = item
            }
        },
        ExtraButtonClick(target) {
            let e = {}
            ;({ index: e.index, row: e.row } = target)
            if (this[target.emit]) {
                this[target.emit](e)
            } else {
                this.$emit(target.emit, e)
            }
        },
        // 上一日，下一日,上一周，下一周,上一月，下一月
        addDate(prevOrNext) {
            let that = this
            if (prevOrNext == 0) {
                this.dateValue = that.$moment()
            }
            that.changeDatePickerSetScheduleTimeSpan(that.dateValue, prevOrNext)
        },
        changeDatePickerSetScheduleTimeSpan(date, prevOrNext = 0) {
            let that = this
            that.scheduleTimeSpan = []
            if (that.viewType == `week`) {
                if (prevOrNext == 0) {
                    let weekOfDay = that.$moment(this.dateValue).format(`E`)
                    let firstday = that
                        .$moment(this.dateValue)
                        .subtract(weekOfDay - 1, `days`)
                        .format(`YYYY-MM-DD`)
                    let endday = that
                        .$moment(this.dateValue)
                        .subtract(weekOfDay - 7, `days`)
                        .format(`YYYY-MM-DD`)
                    this.start = firstday
                    this.end = endday
                    this.dateValue = firstday
                } else {
                    let prev = that
                        .$moment(this.dateValue)
                        .subtract(-prevOrNext, `week`)
                        .startOf(`week`)
                        .format(`YYYY-MM-DD`)
                    let next = that
                        .$moment(this.dateValue)
                        .subtract(-prevOrNext, `week`)
                        .endOf(`week`)
                        .format(`YYYY-MM-DD`)
                    this.start = prev
                    this.end = next
                    this.dateValue = prev
                }
                this.year = that.$moment(this.dateValue).year()
                this.month = that.$moment(this.dateValue).month() + 1
                this.week = that.$moment(this.dateValue).week()
                this.day = that.$moment(this.dateValue).format(`YYYY-MM-DD`)

                this.scheduleTimeSpan = []
                for (let i = 0; i < 7; i++) {
                    let day = that
                        .$moment(this.start)
                        .add(i, `d`)
                        .format(`YYYY-MM-DD`)
                    that.scheduleTimeSpan.push(day)
                }
            } else {
                if (prevOrNext !== 0) {
                    let prev = that
                        .$moment(this.dateValue)
                        .subtract(-prevOrNext, `day`)
                        .format(`YYYY-MM-DD`)
                    this.dateValue = prev
                }
                this.year = that.$moment(this.dateValue).year()
                this.month = that.$moment(this.dateValue).month() + 1
                this.week = that.$moment(this.dateValue).week()
                this.day = that.$moment(this.dateValue).format(`YYYY-MM-DD`)
                this.start = that.$moment(this.dateValue).format(`YYYY-MM-DD`)
                this.end = that.$moment(this.dateValue).format(`YYYY-MM-DD`)
                that.scheduleTimeSpan.push(this.day)
            }
        },
        loadCurrentUserSchedules() {
            let that = this
            return new Promise(resolve => {
                let req = that.myaxios.get(`/api/AcisSystem/DicSchedule/GetScheduleByUserId?userId=${(this.currentUser && this.currentUser.id) || 0}&type=1`)
                req.then(data => {
                    if (data && data.length > 0) {
                        data.map(i => {
                            i.id = String(i.id)
                        })
                        that.schedules = data
                        that.activeScheduleId = that.schedules[0].id
                        that.activeSchedule = that.schedules[0]
                        that.viewType = that.activeSchedule.default_view == 1 ? `week` : `day`
                    }
                    resolve(that.activeScheduleId)
                })
            })
        },
        loadShiftUserGroup(activeScheduleId) {
            let that = this
            that.schedule_userGroup = []
            return new Promise(resolve => {
                // 获取排班表设置的用户组
                let req = this.myaxios.get(`/api/AcisSystem/ShiftUserGroup/GetUserGroupByScheduleId?scheduleId=${activeScheduleId}`)
                req.then(data => {
                    that.schedule_userGroup = data
                    that.workerList = []
                    that.userGroupForm.userGroup = []
                    _.forEach(this.schedule_userGroup, item => {
                        item.users &&
                            _.forEach(item.users, user => {
                                if (user.worker_id > 0) {
                                    that.workerList.push({
                                        worker_name: user.worker_name,
                                        worker_id: user.worker_id,
                                        worker_code: user.worker_section_name,
                                        back_color: item.back_color || `255,255,255`, // 按组设置背景色，不按人员
                                        shift_user_group_id: item.id
                                    })
                                }
                            })
                        that.userGroupForm.userGroup.push({
                            label: item.name,
                            value: parseInt(item.id)
                        })
                    })
                    resolve(that.schedule_userGroup)
                })
            })
        },
        loadActiveScheduleUserGroupsAndShifts(activeScheduleId) {
            let that = this
            that.loadShiftUserGroup(activeScheduleId)
            // 初始化基础数据
            that.schedule_sifts = []
            that.schedule_sifts_copy = []
            that.schedule_wards = []
            that.schedule_dutys = []

            return new Promise(resolve => {
                // 获取排班表设置的班次
                let req1 = this.myaxios.get(`api/AcisSystem/DicShift/GetShiftByScheduleId?scheduleId=${activeScheduleId}`)
                let req2 = this.myaxios.get(`api/AcisSystem/DicSchedule/Get?id=${activeScheduleId}`)
                this.myaxios.all(req1, req2).then(([data1, schedule]) => {
                    if (schedule && schedule.schedule_wards && schedule.schedule_wards.length > 0) {
                        let wards = _.cloneDeep(schedule.schedule_wards)
                        let tmpwards = []
                        // that.schedule_wards
                        let wardgroups = _.groupBy(wards, `dic_ward_id`)
                        let groupid = 0
                        _.forEach(wardgroups, (value, key) => {
                            let wardrow = {
                                id: groupid,
                                dic_ward_id: parseInt(key),
                                dic_ward_name: value[0].dic_ward_name,
                                count: value.length,
                                enum_ward_type: value.enum_ward_type,
                                rooms: []
                            }
                            wardrow.rooms = value
                                .sort((a, b) => {
                                    if (a.dic_room_id == 0 || b.dic_room_id == 0) {
                                        return b.dic_room_id - a.dic_room_id
                                    }
                                })
                                .map((room, index) => {
                                    return { dic_room_id: room.dic_room_id, dic_room_name: room.dic_room_name, row_counts: room.row_counts, column_counts: room.column_counts }
                                })
                            tmpwards.push(wardrow)
                        })
                        that.schedule_wards = _.cloneDeep(tmpwards)

                        // console.log(`rrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrr`, tmpwards[0])
                        // that.schedule_wards = [tmpwards[0]]
                    }
                    that.schedule_sifts = data1
                    that.schedule_sifts_copy = _.cloneDeep(data1)
                    that.schedule_dutys = schedule.schedule_dutys
                    resolve(that.schedule_sifts)
                })
            })
        },
        loadScheduleResultsAndCreateShiftTable() {
            let that = this
            that.loadScheduleResults().then(results => {})
        },
        loadScheduleResults() {
            let that = this
            that.active_item = [null, null, null, null, null, null, null]
            return new Promise(resolve => {
                let type = 1 // 表示 日视图，周视图也按日视图查
                let status = -1
                let url = `/api/AcisSystem/ScheduleResult/GetScheduleResult?dic_schedule_id=${that.activeScheduleId}&startDT=${that.day}&endDT=${that.day}&type=${type}&status=${status}`
                that.myaxios.get(url).then(data => {
                    if (data != null) {
                        that.schedule_result = data
                        if (that.schedule_result.id == 0) {
                            that.schedule_result = {
                                name: ``,
                                dic_schedule_id: that.activeScheduleId,
                                year: this.year,
                                month: this.month,
                                week: this.week,
                                start_dt: this.start,
                                end_dt: this.end,
                                type: type,
                                status: 1,
                                status_name: `未发布`,
                                remark: that.activeSchedule.remark
                            }
                            that.schedule_result.result_details = data.result_details
                        }
                    } else {
                        // that.schedule_result = {
                        //     result_details: []
                        // }

                        // 之前 如果 下一天 没有 把 result_details 清空，下一天页面显示没有数据，301老师要求，如果下一天没有，不用清空上一天数据，上一天数据直接带过来，改吧改吧保存一下就成下一天数据
                        that.$set(that.schedule_result, `id`, 0)
                        that.$set(that.schedule_result, `name`, ``)
                        that.$set(that.schedule_result, `dic_schedule_id`, that.activeScheduleId)
                        that.$set(that.schedule_result, `year`, this.year)
                        that.$set(that.schedule_result, `month`, this.month)
                        that.$set(that.schedule_result, `week`, this.week)
                        that.$set(that.schedule_result, `start_dt`, this.start)
                        that.$set(that.schedule_result, `end_dt`, this.end)
                        that.$set(that.schedule_result, `type`, type)
                        that.$set(that.schedule_result, `status`, 1)
                        that.$set(that.schedule_result, `status_name`, `未发布`)
                        that.$set(that.schedule_result, `remark`, that.activeSchedule.remark)
                    }
                    that.schedule_result.result_details = _.map(that.schedule_result.result_details, detail => {
                        detail.schedule_date = that.$moment(detail.schedule_date).format(`YYYY-MM-DD`)
                        return detail
                    })
                    that.getDutysRemarks(that.schedule_result.result_details)
                    resolve(that.schedule_result)
                })
            })
        },
        createRemarkDetail(scheduleWardId, roomId, duty) {
            let newresultWorker = {
                dic_schedule_ward_id: scheduleWardId,
                room_id: roomId,
                worker_id: 0,
                enum_worker_duty_id: duty.enum_worker_duty_id,
                display_order: -1,
                dic_schedule_id: this.activeScheduleId,
                remark: duty.remark
            }

            let item = _.find(
                this.schedule_result.result_details,
                x =>
                    x.dic_schedule_ward_id == newresultWorker.dic_schedule_ward_id &&
                    x.room_id == newresultWorker.room_id &&
                    x.enum_worker_duty_id == newresultWorker.enum_worker_duty_id &&
                    x.display_order == newresultWorker.display_order &&
                    x.worker_id == 0
            )

            if (!item) {
                this.schedule_result.result_details.push(newresultWorker)
            } else {
                this.$set(item, `remark`, newresultWorker.remark)
            }
        },
        getDutysRemarks(resultDetails) {
            let that = this
            let remarks = _.filter(resultDetails, x => x.worker_id == 0 && x.display_order == -1 && x.remark != null)
            _.forEach(that.schedule_wards, ward => {
                _.forEach(ward.rooms, room => {
                    _.forEach(room.schedule_dutys, duty => {
                        duty.remark = that.getRoomDutyRemark(remarks, ward.id, room.id, duty)
                    })
                })
            })
        },
        save(publish, isbtnSave) {
            let that = this
            return new Promise(resolve => {
                that.schedule_result.year = this.year
                that.schedule_result.month = this.month
                that.schedule_result.week = this.week
                that.schedule_result.start_dt = this.day
                that.schedule_result.end_dt = this.day
                that.schedule_result.type = 1
                that.schedule_result.dic_schedule_type = 1 // 301 按区排班
                if (that.schedule_result.result_details && that.schedule_result.result_details.length == 0) {
                    if (isbtnSave) {
                        let that = this
                        let url = `/api/AcisSystem/ScheduleResult/SaveEmptyScheduleResultDetail?schedule_result_id=${that.schedule_result.id}`
                        var reps = this.myaxios.post(url)
                        reps.then(data => {
                            this.showedit = false
                            // 自动保存不用提示,按钮保存提示
                            this.loadScheduleResultsAndCreateShiftTable()
                            that.$message.success(`${publish == 2 ? `发布成功` : `信息保存成功`}`)
                        })
                        return
                    } else {
                        return
                    }
                }

                _.forEach(that.schedule_wards, ward => {
                    _.forEach(ward.rooms, room => {
                        _.forEach(room.schedule_dutys, duty => {
                            if (duty.remark) {
                                that.remarks.push(duty.remark)
                                that.createRemarkDetail(ward.id, room.id, duty)
                            }
                        })
                    })
                })
                that.schedule_result.result_details.forEach(detail => {
                    detail.biz_schedule_result_id = that.schedule_result.id
                    detail.dic_schedule_id = that.schedule_result.dic_schedule_id
                    detail.schedule_date = that.day
                })

                if (publish == 2) {
                    return that
                        .$confirm(`请确认是否发布`, `确认提示`, {
                            confirmButtonText: `确定`,
                            cancelButtonText: `取消`,
                            type: `warning`,
                            closeOnClickModal: false
                        })
                        .then(() => {
                            if (that.viewType == `week`) {
                                // 如果是周视图发布，逻辑复杂些
                                that.publishWeekResult(that.schedule_result)
                            } else {
                                that.saveDetail(publish, that.schedule_result, isbtnSave)
                            }
                        })
                        .catch(e => {})
                } else {
                    that.saveDetail(publish, that.schedule_result, isbtnSave)
                }

                resolve()
            })
        },
        saveDetail(publish, result, isbtnSave) {
            let that = this
            let url = `/api/AcisSystem/ScheduleResult/SaveScheduleResultDetail?publish=${publish}`
            var reps = this.myaxios.post(url, result)
            reps.then(data => {
                if (isbtnSave) {
                    this.showedit = publish != 2
                    this.isHide = true
                    // 自动保存不用提示,按钮保存提示
                    this.loadScheduleResultsAndCreateShiftTable()
                    that.$message.success(`${publish == 2 ? `发布成功` : `信息保存成功`}`)
                }
            })
        },
        getRoomDutyRemark(detail, wardid, roomid, duty) {
            let item = detail.find(x => x.dic_schedule_ward_id == wardid && x.room_id == roomid && x.enum_worker_duty_id == duty.enum_worker_duty_id)
            return (item && item.remark) || ``
        },
        del() {
            let that = this
            if (that.schedule_result.id <= 0) {
                that.schedule_result.result_details = []
                return
            }
            let req = this.myaxios.delete(`/api/AcisSystem/ScheduleResult/Delete?id=${that.schedule_result.id}`)
            req.then(data => {
                that.$message.success(`排班已删除！`)
                that.loadScheduleResultsAndCreateShiftTable()
                that.schedule_result.result_details = []
            }).catch(e => console.log(e))
        },
        publishWeekResult(result) {
            let that = this
            let url = `/api/AcisSystem/ScheduleResult/SaveScheduleResultDetail?publish=2`
            let url1 = `/api/AcisSystem/ScheduleResult/UpdateStatus?stutus=2&type=1`
            var reps = this.myaxios.post(url, result)
            reps.then(data => {
                var reps = this.myaxios.post(url1, that.scheduleTimeSpan)
                reps.then(data => {
                    this.loadScheduleResultsAndCreateShiftTable()
                    that.$message.success(`发布成功`)
                })
            })
        },
        unlock(status) {
            this.alterPasswordDialog.data.uid = this.currentUser.username
            this.alterPasswordDialog.data.pwd = null
            this.alterPasswordDialog.dialogFormVisible = true
        },
        saveLock(publish) {
            if (!this.alterPasswordDialog.data.uid || !this.alterPasswordDialog.data.pwd) {
                this.$message.error(`请输入用户名或密码`)
                return
            }
            let user = Object.assign({}, this.alterPasswordDialog.data)
            if (this.$root.PwdEncryptEnabled && this.$root.PwdEncryptEnabled == `1` && this.$root.RsaPublicKeyLogin) {
                let encryptor = new JSEncrypt()
                encryptor.setPublicKey(this.$root.RsaPublicKeyLogin)
                user.pwd = encryptor.encrypt(user.pwd)
            }
            this.myaxios
                .post(`api/AcisSystem/Authorization/Login`, {
                    user_agent: `chrome`,
                    timestamp: new Date().getTime(),
                    data: user
                })
                .then(data => {
                    if (this.schedule_result.id > 0) {
                        this.updateStatus(1)
                    }
                    this.showedit = true
                    this.alterPasswordDialog.dialogFormVisible = false
                })
        },
        updateStatus(publish) {
            let that = this
            if (that.viewType == `week`) {
                var reps = this.myaxios.post(`/api/AcisSystem/ScheduleResult/UpdateStatus?stutus=${publish}&type=1`, that.scheduleTimeSpan)
                reps.then(data => {
                    this.loadScheduleResultsAndCreateShiftTable()
                    that.$message.success(`更新成功`)
                })
            } else {
                return new Promise(resolve => {
                    if (that.schedule_result) {
                        that.schedule_result.status = publish
                    }
                    let url = `/api/AcisSystem/ScheduleResult/Put`
                    var reps = this.myaxios.put(url, that.schedule_result)
                    reps.then(data => {
                        this.loadScheduleResultsAndCreateShiftTable()
                        resolve()
                    })
                })
            }
        },
        exportInfo() {
            let that = this
            let from = null
            let to = null
            let type = 0
            if (that.viewType == `day`) {
                from = this.$moment(that.dateValue).format(`YYYY-MM-DD`)
                to = this.$moment(that.dateValue).format(`YYYY-MM-DD`)
                type = 1
            }
            if (that.viewType == `week`) {
                from = this.$moment(that.start).format(`YYYY-MM-DD`)
                to = this.$moment(that.end).format(`YYYY-MM-DD`)
                type = 2
            }

            this.myaxios
                .get(`/api/AcisSystem/ScheduleResult/GetScheduleResultForExport`, { dic_schedule_id: that.activeScheduleId, from: from, to: to, type: type })
                .then(data => {
                    if (data.length <= 0) {
                        this.$message.warning(`暂无导出数据`)
                        return
                    }
                    this.myaxios.export_excel_Extradata(`api/Operation/Home/ExcelFile_Schedule`, data, `排班结果.xls`, data[0].标题)
                })
                .catch(e => {
                    console.log(e)
                })
        },
        printInfo() {
            this.$message.warning(`开发中,敬请期待...`)
        },
        copyPreWeek(prevDate, copyToDate) {
            let that = this
            return new Promise(resolve => {
                let url = `/api/AcisSystem/ScheduleResult/GetScheduleResult?dic_schedule_id=${that.activeScheduleId}&startDT=${prevDate}&endDT=${prevDate}&type=1`
                let url1 = `/api/AcisSystem/ScheduleResult/GetScheduleResult?dic_schedule_id=${that.activeScheduleId}&startDT=${copyToDate}&endDT=${copyToDate}&type=1`
                // 获取上一周/日/月排班记录
                let req = this.myaxios.get(url)
                // 获取本周/日/月排班记录
                let req1 = this.myaxios.get(url1)
                this.myaxios.all(req, req1).then(([preSchedule, Schedule]) => {
                    if (!preSchedule || (preSchedule && preSchedule.id == 0 && preSchedule.result_details.length == 0)) {
                        if (that.viewType == `day`) {
                            this.$message.warning(`上一天没有排班记录!`)
                            return
                        } else {
                            return
                        }
                    }

                    let copyObj = {
                        preYear: null,
                        premonth: null,
                        preweek: null,
                        preday: prevDate,
                        year: that.year,
                        week: that.week,
                        month: that.month,
                        start_dt: copyToDate,
                        end_dt: copyToDate,
                        day: copyToDate,
                        type: 1
                    }
                    if (preSchedule && preSchedule.id == 0) {
                        let dt = preSchedule.result_details[0].schedule_date
                        that.$set(copyObj, `preYear`, that.$moment(dt).year())
                        that.$set(copyObj, `premonth`, that.$moment(dt).month() + 1)
                        that.$set(copyObj, `preweek`, that.$moment(dt).week())
                    } else {
                        that.$set(copyObj, `preYear`, preSchedule.year)
                        that.$set(copyObj, `premonth`, preSchedule.month)
                        that.$set(copyObj, `preweek`, preSchedule.week)
                    }
                    if (that.viewType == `day`) {
                        if (Schedule && (Schedule.id !== 0 || (Schedule.id == 0 && Schedule.result_details.length > 0))) {
                            return that
                                .$confirm(`当前日期已经有排班记录,复制上一天将覆盖当前数据,请确认`, `确认提示`, {
                                    confirmButtonText: `确定`,
                                    cancelButtonText: `取消`,
                                    type: `warning`,
                                    closeOnClickModal: false
                                })
                                .then(() => {
                                    that.copyPost(copyObj)
                                })
                                .catch(e => {})
                        } else {
                            return that
                                .$confirm(`是否确认复制上一天排班到当前列表`, `确认提示`, {
                                    confirmButtonText: `确定`,
                                    cancelButtonText: `取消`,
                                    type: `warning`,
                                    closeOnClickModal: false
                                })
                                .then(() => {
                                    that.copyPost(copyObj)
                                })
                                .catch(e => {})
                        }
                    } else {
                        // 周视图是循环复制日视图的方式，不用复制一天提示一天
                        that.copyPost(copyObj)
                    }
                })
            })
        },
        copyPost(copyObj) {
            let that = this
            let copydata = {
                dic_schedule_id: that.activeScheduleId,
                preyear: copyObj.preYear,
                preweek: copyObj.preweek,
                premonth: copyObj.premonth,
                preday: copyObj.preday,
                year: copyObj.year,
                week: copyObj.week,
                month: copyObj.month,
                start_dt: copyObj.start_dt,
                end_dt: copyObj.end_dt,
                day: copyObj.day,
                copy_to_date: copyObj.day,
                type: copyObj.type
            }
            let url = `/api/AcisSystem/ScheduleResult/CopyPre?type=1`
            var reps = this.myaxios.post(url, copydata)
            reps.then(data => {
                this.loadScheduleResultsAndCreateShiftTable()
            })
        },
        copyToDate() {
            this.copyTo.dialogFormVisible = true
            this.copyTo.from_to = this.$moment(this.day).add(-1, `days`)
        },
        copyToDateConfirm() {
            let that = this
            if (that.viewType == `day`) {
                let prevStart = this.$moment(that.copyTo.from_to).format(`YYYY-MM-DD`)
                that.copyPreWeek(prevStart, that.day)
            } else {
                for (let index = 0; index < that.scheduleTimeSpan.length; index++) {
                    let day = that.scheduleTimeSpan[index]
                    let prevday = that
                        .$moment(day)
                        .subtract(1, `week`)
                        .format(`YYYY-MM-DD`)
                    that.copyPreWeek(prevday, day)
                }
            }
            that.copyTo.dialogFormVisible = false
        },
        publishHisRecord() {
            let that = this
            that.publishRecord.dialogFormVisible = true
            return new Promise(resolve => {
                var reps = this.myaxios.get(`/api/AcisSystem/ScheduleResult/GetSchedulePublishLog`, { begin: that.rdate[0], end: that.rdate[1] })
                reps.then(data => {
                    // that.publishRecord.data = data

                    that.publishRecord.data = _.map(data, d => {
                        d.dic_section = this.getSectionNameById(d.dic_section_id)
                        d.dic_ward = this.getWardNameById(d.dic_ward_id)
                        return d
                    })

                    resolve()
                })
            })
        },
        getSectionNameById(id) {
            if (!id) return ``
            let item = _.find(this[`section_auth`], x => x.value == parseInt(id))
            if (item) {
                return item.label || ``
            }
            return ``
        },
        getWardNameById(id) {
            if (!id) return ``
            let item = _.find(this[`ward_auth`], x => x.value == id)
            if (item) {
                return item.label || ``
            }
            return ``
        },
        showRemarkVisible(dicwardid, roomid, roomname, dicshiftId, rowIdx, cellIdx) {
            let that = this
            let workerdutyid = that.roleCols[cellIdx - 1]
            if (this.schedule_result.status == 1) {
                this.roleremark.dialogFormVisible = true
                let item = that.getResultDetailItem(dicwardid, workerdutyid, roomname, dicshiftId, rowIdx, cellIdx)
                if (item) {
                    this.roleremark.resultItem = _.cloneDeep(item)
                } else {
                    this.roleremark.resultItem = {
                        dic_schedule_id: that.activeScheduleId,
                        schedule_date: that.$moment(that.day).format(`YYYY-MM-DD`),
                        dic_ward_id: dicwardid,
                        room_id: roomid,
                        room_name: roomname,
                        enum_worker_duty_id: workerdutyid,
                        rowIdx: rowIdx,
                        cellIdx: cellIdx,
                        remark: null
                    }
                }
            }
        },
        saveRemark(remarkItem) {
            // let that = this
            // if (!remarkItem.remark) {
            //    this.$message.error(`请录入备注信息！`)
            //    return
            // }
            let item = this.getResultDetailItem(remarkItem.dic_ward_id, remarkItem.enum_worker_duty_id, remarkItem.room_name, remarkItem.rowIdx, remarkItem.cellIdx)
            if (item) {
                item.remark = remarkItem.remark
            } else {
                this.schedule_result.result_details.push(remarkItem)
            }
            this.roleremark.dialogFormVisible = false
            this.$forceUpdate()
        },
        saveNotice(content) {
            let that = this
            let url = `/api/AcisSystem/DicSchedule/PutNotice?id=${this.notice.scheduleId}&content=${this.notice.content}`
            var reps = this.myaxios.put(url)
            reps.then(data => {
                that.notice.content = ``
                that.notice.scheduleId = 0
                that.notice.dialogFormVisible = false
                that.activeSchedule.notice = content
            })
            this.$forceUpdate()
        },
        showNotice(activeShedule) {
            this.notice.dialogFormVisible = true
            this.notice.content = this.activeSchedule.notice
            this.notice.scheduleId = this.activeSchedule.id
        },
        showShiftScheduleInfo(shiftId) {
            let that = this
            if (shiftId > 0) {
                that.shiftSchedule.shiftId = shiftId
                that.shiftSchedule.dialogFormVisible = true
                that.ReloadListData()
            }
        },
        // 调用搜狗输入法
        handlerSoGoInput() {
            window.location.href = `Handinput://test`
        },
        // 关闭搜狗手写输入法
        closeSoGoInput() {
            if (window.ActiveXObject || `ActiveXObject` in window) {
                // eslint-disable-next-line
                let cmd = new ActiveXObject(`WScript.Shell`)
                cmd.run(`taskkill /f /t /im handinput.exe`, 0)
            } else {
                // 非IE
            }
        }
    },
    watch: {
        activeScheduleId: function() {
            if (this.activeScheduleId != 0) {
                let item = _.find(this.schedules, x => x.id == this.activeScheduleId)
                if (item) {
                    this.activeSchedule = item
                    this.viewType = this.activeSchedule.default_view == 1 ? `week` : `day`
                }
                this.loadActiveScheduleUserGroupsAndShifts(this.activeScheduleId).then(sifts => {
                    this.loadScheduleResultsAndCreateShiftTable()
                })
            }
        },
        dateValue: function() {
            let that = this
            that.changeDatePickerSetScheduleTimeSpan(that.dateValue, 0)
            if (this.activeScheduleId != 0) {
                this.loadScheduleResultsAndCreateShiftTable()
            }
        },
        viewType: function() {
            this.dateValue = this.$moment()
        },
        rdate: function() {
            this.publishHisRecord()
        },
        shiftrdate: function() {
            this.ReloadListData()
        },
        dic_worker_id: function() {
            this.ReloadListData()
        },
        shift_config_columns: function() {
            this.ReloadListData()
        },
        'userGroupForm.workerinfo.name': function(newvalue, oldval) {
            if (oldval && this.userGroupForm.firstOpen) {
                this.userGroupForm.workerinfo = {
                    name: newvalue,
                    is_deleted: false
                }
            }
        },
        active_item: function(newvalue, oldval) {
            // 判断旧单元格，新单元格是否有人
            if (oldval && newvalue && (oldval[2] != null || oldval[4] != null) && (newvalue[2] != null || newvalue[4] != null)) {
                this.o_active_item = oldval
                // oldcellItem =null 表示点击了空的单元格，先单击空的单元格，在点击 一个 有人的单元格，则完成人员调换
                // 给 旧的位置去找找看有没有人在这个格子
                let oldcellItem = this.getResultDetailItem(oldval[0], oldval[3], oldval[2], oldval[4], oldval[5], oldval[6])
                // 给 新的位置去找找看有没有人在这个格子
                let newcellItem = this.getResultDetailItem(newvalue[0], newvalue[3], newvalue[2], newvalue[4], newvalue[5], newvalue[6])
                // 哈哈把位置换一下吧
                if (!oldcellItem && newcellItem) {
                    this.$set(newcellItem, `dic_ward_id`, oldval[0])
                    this.$set(newcellItem, `room_id`, oldval[1])
                    this.$set(newcellItem, `room_name`, oldval[2])
                    this.$set(newcellItem, `enum_worker_duty_id`, oldval[3])
                    this.$set(newcellItem, `dic_shift_id`, oldval[4])
                    this.$set(newcellItem, `rowIdx`, oldval[5])
                    this.$set(newcellItem, `cellIdx`, oldval[6])
                }
            }
        },
        'roleremark.dialogFormVisible': {
            handler(newvalue, oldval) {
                if (oldval == true && newvalue == false) {
                    this.closeSoGoInput()
                }
            },
            deep: true // 设置 deep 选项为 true，实现深度监听
        }
    }
}
</script>
<style scoped lang="less">
.schedulesetup {
    background: #ffffff;
    font-size:12px;
    height: 100%;
    .schedule_logo {
        width: 48px;
        height: 48px;
        margin-right: 3px;
    }

    .user_left_box {
        border: 2px solid #ebeef5;
        width: 200px;
        float: left;
        position: absolute;
        top: 43px;
        right: 24px;
        z-index: 1000;
        .submenu_user {
            .user {
                padding-left: 0 !important;
                padding-right: 0;
                min-width: 100px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }
    }

    /deep/ table {
        // border-left: 1px solid #ebeef5;
        // border-top: 1px solid #ebeef5;
        // border-bottom: 1px solid #ebeef5;
        background: black;
    }
    th {
        padding: 0 0 0 0;
    }
    .tdflex{
        display: flex;
        flex-wrap: wrap;
        max-height: 20px;
    }
    .roomtr {
        height: 20px !important;
        max-height: 20px !important;
        line-height: inherit !important;
        background: #a5cdd5;
        color:#3c5657;
        white-space: nowrap; /* 防止换行 */
        overflow: hidden; /* 隐藏溢出内容 */
        text-overflow: ellipsis; /* 显示省略号 */
    }
    .customroomstyle {
        font-size: 12px;
    }

    /deep/ .el-header {
        margin: 2px 0px !important;
        padding: 0px !important;
    }

    /deep/ .header {
        height: 20px;
        padding: 0 0px;
        background: var(--primary-color, #009688);
        color: #ffffff;
        font-size: 15px;
        .lefttitle {
            width: 80px;
            max-width: 80px;
        }
    }

    /deep/ .room {
        height: 28px !important;
        min-height: 28px !important;
    }

    /deep/ .el-main {
        padding: 0 0px;
        background: #ffffff;
    }

    /deep/ .el-footer {
        font-size: 22px;
        padding: 0px 0px;
    }

    /deep/ .el-dialog__wrapper .el-dialog__body .el-form-item__label {
        width: 130px !important;
        padding-top: 8px;
    }

    /deep/ .el-dialog__wrapper .el-dialog__body .el-form-item__content {
        margin-left: 140px !important;
    }

    /deep/ .el-tag--warning {
        color: orange;
        border: 1px solid orange;
        // height: 28px;
        // line-height: 28px;
    }

    /deep/ .el-select__tags {
        padding-left: 3px;
    }

    /deep/ .item {
        .item__txt {
            min-height: 150px !important;
            box-sizing: border-box;
            // border: 1px solid transparent;
        }

        .item__txt--hover {
            border: 1px solid #dddddd;
            border-radius: 4px;
            cursor: pointer;
            background-color: #ffffff;
        }

        .item__txt--click {
            border: 2px solid #0c9781;
            background-color: #ffffff;
        }
    }

    /deep/ .elSelect-Class {
        .el-input {
            input {
                height: 42px !important;
            }
        }
    }

    /deep/ .setworkerdialog {
        .el-dialog__header {
            display: none;
        }

        .el-dialog__body {
            background: none;
            min-height: 100px !important;
        }

        .remotemultiselect {
            .el-input {
                input {
                    min-height: 80px !important;
                    width: 340px;
                }
            }

            .el-input__inner {
                padding-left: 5px !important;
            }

            &.el-input--suffix .el-input__inner {
                padding-right: 5px !important;
            }

            .el-input--suffix .el-input__inner {
                padding-right: 5px !important;
            }

            .el-input__prefix {
                display: none;
            }

            .el-select__input {
                padding-left: 4px;
            }
        }
    }

    .el-table th {
        background-color: #fafafa !important;
    }

    #shiftworkerlist {
        el-table th {
            background: var(--primary-color, #009688) !important;
        }

        .td {
            height: 40px !important;
            min-height: 40px !important;
        }
    }
}

.no-data {
    display: table;
    width: 100%;
    height: 100px;
    text-align: center;
    vertical-align: middle;
    margin-top: 20px;
    background: #ffffff;
}

.OnInTableTd {
    width: 42px;
    max-width: 42px;
    transform: rotate(0);
    /* 修正文字方向，确保从上到下顺序 */
    margin: auto;
    text-align: center;
    /*border-right: 1px solid black; */
    background: #ffffff;
    padding: 0 0 0 0;
    height: 58px;
    max-height: 58px;
    line-height: inherit !important;
    font-size:15px;
}

.OnInTableTd:nth-last-child(1):after {
    display: none;
}

.OnInTableDiv {
    height: 58px;
    top: 0;
    margin: auto 0;
    display: flex;
    align-content: normal;
    .vertical_text {
        writing-mode: vertical-rl;
        transform: rotate(0);
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}

.noBorderRight{
    border: 0px !important;
}

.td_div {
    width: 98%;
    height: 56px;
    border: 1px solid var(--primary-color, #009688);
    text-align: center;
    display: flex;
    user-select: none;
    .vertical_text {
        writing-mode: vertical-rl;
        /* 从上到下，从右到左 */
        transform: rotate(0);
        /* 修正文字方向，确保从上到下顺序 */
        text-align: center;
        align-items: center;
        justify-content: center;
    }
}

.OnInRemarkTd {
    width: 42px;
    max-width: 42px;
    transform: rotate(0);
    /* 修正文字方向，确保从上到下顺序 */
    margin: auto;
    text-align: center;
    background: #ffffff;
    padding: 0 0 0 0;
    height: 20px;
    max-height: 20px;
    line-height: inherit !important;
}

.OnInRemarkTd:nth-last-child(1):after {
    display: none;
}

.OnInRemarkDiv {
    height: 20px;
    top: 0;
    margin: auto 0;
    display: flex;
    align-content: normal;
    .vertical_text {
        writing-mode: vertical-rl;
        transform: rotate(0);
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}

/deep/ .el-submenu__title {
    padding-left: 0px !important;
}

.user {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin: 2px 5px 5px 5px;
    border: solid 1px;
    border-radius: 3px;
    cursor: move;
    font-size: 20px;
    color: #2c3e50 !important;
    height: 50px;
    line-height: 50px;
    padding: 0 45px;
}
.user:hover {
    outline: 0;
    background-color: var(--primary-light, #e6f5f3) !important;
}

.shift {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding: 2px 10px;
    margin: 5px 10px 5px 2px;
    height: 20px;
    line-height: 20px;
    border: solid 0px;
    border-radius: 3px;
    background: #ebeef5;
    cursor: move;
    font-size: 15px;
    color: #414d6c;
}

.userlisttitle {
    height: 50px;
    line-height: 50px;
    font-size: 20px;
    font-weight: bold;
    text-align: left;
    padding-left: 20px;
    border-bottom: 2px solid #ebeef5;
    background: var(--primary-color, #009688);
    color: #fff;
}

.usertag {
    margin-right: 5px;
    margin-bottom: 3px;
    min-width: 83px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 170px;
}

/deep/ .el-tabs__nav-wrap::after {
    background-color: #ffffff !important;
}

.btn-group-custom-style {
    /deep/ .el-button {
        &:not(:first-of-type) {
            margin-left: 0 !important;
            border-left-width: 0;
        }

        &:not(:last-of-type) {
            margin-right: 0 !important;
            border-right-width: 0;
        }
    }
}

.ver-hori-center {
    display: flex;
    justify-content: center;
    align-items: center;
}

.redtitle {
    text-align: left;
    font-size: 16px;
    height: 20px;
    line-height: 20px;
    color: red;

    span {
        margin: auto 10px;
    }
}

.sectiontable {
    border: 1px solid rgba(220, 223, 230, 1);

    .sectionname {
        height: 32px;
        line-height: 32px;
        white-space: nowrap;
        overflow: hidden;
        border: 1px solid rgba(235, 238, 245, 1);
    }

    .sectionselect {
        height: 32px;
        line-height: 32px;
        color: red;
        border: 1px solid rgba(235, 238, 245, 1);
    }
}

#GroupUser /deep/ .el-form-item__label {
    width: 80px !important;
    padding-top: 0 !important;
    margin-bottom: 0px !important;
}

#GroupUser /deep/ .el-form-item {
    padding-top: 0 !important;
    margin-bottom: 10px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/ScheduleShift/UnLoginDoctorScheduleSetup.vue